export const BADGE_PLACEHOLDER = '/images/badges/svg/badge_placeholder.svg';

/**
 * ref: BadgeUnit.java
 */
export const BADGE_UNIT_KEYS = {
    distance: 'mi_km', // 1
    distanceAlt: 'ft_m', // 2
    activities: 'activities', // 3
    days: 'days', // 4
    steps: 'steps', // 5
    miles: 'mi', // 6
    seconds: 'seconds', // 7
    challenges: 'challenges', // 8
    kilocalories: 'kilocalories', // 9
    weeks: 'weeks', // 10
    likes: 'likes' // 11
};

export const BADGE_ASSOC_TYPE_KEYS = {
    ACTIVITY: 'ACTIVITY',
    GROUP_CHALLENGE: 'GROUP_CHALLENGE',
    ADHOC_CHALLENGE: 'ADHOC_CHALLENGE',
    VIVOFITJR_CHALLENGE: 'VIVOFITJR_CHALLENGE',
    VIVOFITJR_TEAM_CHALLENGE: 'VIVOFITJR_TEAM_CHALLENGE',
    DAY: 'DAY',
    NO_LINK: 'NO_LINK',
    BADGE_CHALLENGE: 'BADGE_CHALLENGE'
};

export const BADGE_TYPES = {
    ONE_TIME: 1,
    TRAINING_CLASS: 2,
    REPEATABLE: 3,
    CUMULATIVE: 4,
    LIMITED_ANNUAL: 5,
    LIMITED_SINGLE: 6
};

export const REDEMPTION_TYPES = {
    GCM: 'GCM',
    WEB: 'WEB',
    BOTH: 'BOTH'
};

/**
 * BadgeCategory .java
 */
export const BADGE_CATEGORY_KEYS = {
    ACTIVITIES: 'activities', // 1
    RUNNING: 'running', // 2
    CYCLING: 'cycling', // 3
    CHALLENGES: 'challenges', // 4
    STEPS: 'steps', // 5
    CONNECT_FEATURES: 'connect_features', // 6
    HEALTH: 'health', // 7
    TACX_MULTI_STAGE: 'tacx_multi_stage', // 8
    DIVING: 'diving' // 9
};
